<template>
	<v-app>
		<v-navigation-drawer
			app
			class="appBar"
			:class="{
				appBarTopLight: $vuetify.breakpoint.mdAndDown && !$vuetify.theme.isDark,
				appBarTopDark: $vuetify.breakpoint.mdAndDown && $vuetify.theme.isDark,
			}"
			width="200"
			v-model="drawer"
			mobile-breakpoint="1023"
		>
			<v-list v-if="(!$vuetify.breakpoint.lgAndUp && drawer) || drawer" style="height: 80px">
				<a :href="landingUrl">
					<logo style="width: 150px; height: 60px;" />
				</a>
			</v-list>
			<v-divider />
			<v-list v-if="profile" nav class="text-left">
				<v-list-item link :to="{ name: 'all-activities' }">
					<v-icon
						class="pr-2"
						:class="
							$route.matched.some(matched => matched.name === 'management')
								? 'primary--text'
								: ''
						"
					>
						mdi-chart-timeline
					</v-icon>
					<v-list-item-title>Actividades</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/places">
					<v-icon class="pr-2" :class="$route.name === 'places' ? 'primary--text' : ''">
						mdi-office-building-marker-outline
					</v-icon>
					<v-list-item-title>Establecimientos</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/persons">
					<v-icon class="pr-2" :class="$route.name === 'persons' ? 'primary--text' : ''">
						mdi-account-circle-outline
					</v-icon>
					<v-list-item-title>Personas</v-list-item-title>
				</v-list-item>
				<v-list-item link target="_blanck" href="https://certplag.cl/servicios/pagos">
					<v-icon class="pr-2">
						mdi-hand-heart
					</v-icon>
					<v-list-item-title class="body-2">Pagos</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/audit">
					<v-icon class="pr-2" :class="$route.name === 'audit' ? 'primary--text' : ''">
						mdi-book-open-outline
					</v-icon>
					<v-list-item-title>Auditoria</v-list-item-title>
				</v-list-item>
				<!-- <v-list-item active-class="elevation-2" style="height: 50px" link to="/billing">
					<v-icon class="pr-2" :class="$route.name === 'billing' ? 'primary--text' : ''">
						mdi-account-cash
					</v-icon>
					<v-list-item-title>Facturación</v-list-item-title>
				</v-list-item> -->
				<v-list-item link to="/account">
					<v-icon class="pr-2" :class="$route.name === 'profile' ? 'primary--text' : ''">
						mdi-account-cog-outline
					</v-icon>
					<v-list-item-title>Cuenta</v-list-item-title>
				</v-list-item>
				<v-list-item link to="/contact-us">
					<v-icon class="pr-2" :class="$route.name === 'contact' ? 'primary--text' : ''">
						mdi-email-send-outline
					</v-icon>
					<v-list-item-title>Contacto</v-list-item-title>
				</v-list-item>
				<v-list-item v-if="profile.role == 'superUser'" link to="/support">
					<v-icon class="pr-2" :class="$route.name === 'support' ? 'primary--text' : ''">
						mdi-face-agent
					</v-icon>
					<v-list-item-title>Soporte</v-list-item-title>
				</v-list-item>
				<v-list-item v-if="profile.role == 'superUser'" link to="/dashboard">
					<v-icon
						class="pr-2"
						:class="$route.name === 'dashboard' ? 'primary--text' : ''"
					>
						mdi-view-dashboard-outline
					</v-icon>
					<v-list-item-title>Panel de control</v-list-item-title>
				</v-list-item>
				<!-- <v-list-item
					active-class="primary--text"
					link
					@click="requestNotificationPermissions"
				>
					<v-icon>mdi-bell-outline</v-icon>
					<v-list-item-title>Notificaciones</v-list-item-title>
				</v-list-item> -->
				<v-divider />
				<v-spacer></v-spacer>
				<v-list-item
					v-if="loggedIn"
					class="mb-5"
					active-class="primary--text"
					@click="logout"
					data-cy="adminLogOut"
				>
					<v-icon>mdi-logout</v-icon>
					<v-list-item-title>Cerrar sesión</v-list-item-title>
				</v-list-item>
				<v-list-item v-else active-class="primary--text" to="/auth">
					<v-icon>mdi-account-arrow-light-outline</v-icon>
					<v-list-item-title>Iniciar sesión</v-list-item-title>
				</v-list-item>
			</v-list>
			<v-skeleton-loader
				v-else
				class="ma-2"
				type="list-item, list-item, list-item, list-item, list-item, list-item"
			></v-skeleton-loader>
		</v-navigation-drawer>
		<!-- appbar desktop -->
		<v-app-bar
			v-if="$vuetify.breakpoint.lgAndUp"
			app
			height="30"
			:class="{
				appBarTopLight: !$vuetify.theme.isDark,
				appBarTopDark: $vuetify.theme.isDark,
				backgroundMorado: !$vuetify.theme.isDark,
			}"
		>
			<template v-if="profile">
				<avatar
					size="25"
					class="ma-2"
					:name="profile.name"
					:last-name="profile.lastName"
					:url="profile.img"
					filled
					hide-details
				/>
				<router-link to="/account" style="text-decoration: none">
					<v-list-item class="text-left">
						<v-list-item-content>
							<v-list-item-title class="text-capitalize">
								{{ profile.name }}
								{{ profile.lastName ? profile.lastName : '' }}
								Administrador
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</router-link>
			</template>
			<v-spacer />
			<div class="title text--secondary">
				{{ $route.meta.title }}
			</div>
			<v-spacer />
			<div style="min-width: 300px" class="text-right">
				<v-btn icon text @click="toggleTheme" class="ma-2">
					<v-icon small>mdi-theme-light-dark</v-icon>
				</v-btn>

				<v-btn icon text @click="drawer = !drawer" class="ma-2">
					<v-icon class="text--secondary">mdi-menu</v-icon>
				</v-btn>
			</div>
		</v-app-bar>
		<!--  appbar mobile -->
		<v-app-bar v-else app class="appBarTop">
			<!-- <v-icon class="mr-2" small @click="requestNotificationPermissions"
				>mdi-bell-outline</v-icon
			> -->
			<v-icon class="mr-2 " small @click="toggleTheme">mdi-theme-light-dark</v-icon>
			<v-app-bar-nav-icon class="mr-2" dense @click.stop="drawer = !drawer" />
			<v-spacer />
			<div class="title text--secondary">
				{{ $route.meta.title }}
			</div>
			<v-spacer />
			<v-toolbar-title v-if="!drawer">
				<a :href="landingUrl">
					<v-avatar color="transparent">
						<logo style="max-height: 80px;" />
					</v-avatar>
				</a>
			</v-toolbar-title>
		</v-app-bar>
		<v-main>
			<transition-page>
				<router-view
					:class="{
						routerViewDark: $vuetify.theme.isDark,
						routerViewLight: !$vuetify.theme.isDark,
					}"
				/>
			</transition-page>
		</v-main>
	</v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { logout } from '@/plugins/auth';
import { landing } from '@/config';
export default {
	name: 'DefaultLayout',
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
		Logo: () => import('@/assets/logo'),
		TransitionPage: () => import('@/components/ui/TransitionPage'),
	},
	data() {
		return {
			drawer: null,
			oauthJWT: '',
			showAvatar: false,
		};
	},
	computed: {
		landingUrl() {
			return landing;
		},
		fullName() {
			if (this.profile && this.profile.name)
				return `${this.profile.name} ${this.profile.lastName && this.profile.lastName}`;
			return '';
		},
		...mapGetters({
			profile: 'User/profile',
			places: 'Lodging/places',
		}),
	},
	created() {
		if (this.$vuetify.breakpoint.lgAndUp) {
			this.drawer = true;
		}
	},
	mounted() {
		this.initialFetch();
		if (localStorage.getItem('mode') === 'dark') {
			this.toggleTheme();
		}
	},
	methods: {
		async initialFetch() {
			if (this.loggedIn) {
				try {
					this.setGlobalLoading(true);
					// obtiene lodgigs y places
					await this.getLodgingsOfAdmin();
					// obtienes los tecnicos
					await this.getPersonsByAdmin();
				} catch (error) {
					this.snackbar({
						content: 'Ha ocurrido un error inesperado',
						color: 'error',
					});
				} finally {
					this.setGlobalLoading(false);
				}
			}
		},
		toggleTheme() {
			this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
			if (this.$vuetify.theme.isDark) {
				localStorage.setItem('mode', 'dark');
			} else {
				localStorage.setItem('mode', 'light');
			}
		},
		deleteQueryFromRoute() {
			this.$router.replace({ query: null });
		},
		async logout() {
			logout().then(() => this.$router.replace({ path: '/auth' }));
		},
		...mapActions({
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
			getPersonsByAdmin: 'Person/getPersonsByAdmin',
		}),
		...mapMutations({
			setGlobalLoading: 'User/setGlobalLoading',
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style lang="scss">
.appBar {
	font-family: roboto;
	background-color: transparent !important;
}

.appBarTopLight {
	font-family: roboto;
	background-color: white !important;
}

.appBarTopDark {
	font-family: roboto;
	background-color: black !important;
}
</style>
